import vars from '../helpers';

const textbookItem = document.querySelectorAll('.textbook__item.swiper-slide');
const popup = document.querySelector('.popup#textbook');
const popupContent = popup.querySelector('.popup__content');
const popupTitle = popup.querySelector('.popup__subtitle');
const popupAuthor = popup.querySelector('.popup__author');
const popupWrapper = popup.querySelector('.popup__wrapper');
const popupClose = popup.querySelectorAll('.popup__close, .popup__overlay');

let popupTl = gsap.timeline();

const swiperSlideComponent = (imgPath) => {
	const slide = document.createElement('div');
	slide.classList.add('swiper-slide');

	const picture = document.createElement('picture');

	// const source = document.createElement('source');
	// source.srcset = `${imgPath}.webp, ${imgPath}@2x.webp 2x`;
	// source.type = 'image/webp';

	const img = document.createElement('img');
	img.srcset = `${imgPath}.jpg`
	img.alt = 'example slide';

	picture.appendChild(img);
	// picture.appendChild(source);

	slide.appendChild(picture);
	return slide;
};

const popupOpen = (item) => {
	popupTl.from(popup, {
		onStart() {
			scrollLock.disablePageScroll(popupContent);
			popup.classList.remove('is-hidden');
			popupTitle.innerHTML = item.dataset.title;
			popupAuthor.innerHTML = item.dataset.author;
			JSON.parse(item.dataset.example).forEach((item) => {
				popupWrapper.appendChild(swiperSlideComponent(item));
			});
		},
		duration: 0.3,
		opacity: 0,
		ease: 'power2.out',
		clearProps: 'all',
	});
};

const popupClosed = () => {
	popupTl.to(popup, {
		onComplete() {
			scrollLock.enablePageScroll(popupContent);
			popup.classList.add('is-hidden');
			popupTitle.innerHTML = '';
			popupAuthor.innerHTML = '';

			if (popupWrapper) {
				while (popupWrapper.firstChild) {
					popupWrapper.removeChild(popupWrapper.firstChild);
				}
			}
		},
		duration: 0.3,
		opacity: 0,
		ease: 'power2.out',
		clearProps: 'all',
	});
};

const popupTextbookInit = () => {
	textbookItem.forEach((item) => {
		item.querySelector('.eye').addEventListener('click', () => {
			popupOpen(item);
		});
	});

	popupClose.forEach((close) => {
		close.addEventListener('click', () => {
			popupClosed();
		});
	});
};

export default popupTextbookInit;
